import React from 'react'
import { Box, ButtonBase, withStyles } from '@material-ui/core'
import Eye from '../../../../../../../Assets/Images/icons/eye'
import Schedule from '../../../../../../../Assets/Images/icons/schedule'
import style from './style'
import { EmailIcon, NotificationIcon, SmsIcon } from '../Steps/Components/icons'
import { STEPS } from '../../constants'

function Sidebar({
  classes,
  onSelectStep,
  opened,
  scheduleCount,
  triggerCount,
  memoryTriggerCount,
}) {
  if (scheduleCount || triggerCount) {
    return (
      <div className={classes[`sideSelect${opened ? 'Active' : ''}`]}>
        <div className={classes.sideSelectHeader}>Select action</div>
        <div className={classes.selectItemsContainer}>
          <Box marginBottom="20px">
            <ButtonBase onClick={() => onSelectStep('mail')}>
              <div className={classes.selectItem}>
                <div className={classes.itemIcon}>
                  <EmailIcon />
                </div>
                <div className={classes.itemTitle}>Email</div>
              </div>
            </ButtonBase>
          </Box>
          <Box marginBottom="20px">
            <ButtonBase onClick={() => onSelectStep('sms')}>
              <div className={classes.selectItem}>
                <div className={classes.itemIcon}>
                  <SmsIcon />
                </div>
                <div className={classes.itemTitle}>SMS</div>
              </div>
            </ButtonBase>
          </Box>
          <Box marginBottom="20px">
            <ButtonBase onClick={() => onSelectStep('notification')}>
              <div className={classes.selectItem}>
                <div className={classes.itemIcon}>
                  <NotificationIcon />
                </div>
                <div className={classes.itemTitle}>Push Notification</div>
              </div>
            </ButtonBase>
          </Box>
        </div>
      </div>
    )
  } else if (!memoryTriggerCount) {
    return (
      <div className={classes[`sideSelect${opened ? 'Active' : ''}`]}>
        <div className={classes.sideSelectHeader}>
          Add a Trigger or a Schedule
        </div>
        <div className={classes.selectItemsContainer}>
          <Box marginBottom="20px" maxWidth="300px">
            <ButtonBase onClick={() => onSelectStep('trigger')}>
              <div className={classes.selectItem}>
                <div className={classes.itemIcon}>
                  <Eye width="33" height="22" />
                </div>
                <div className={classes.itemTitle}>Trigger</div>
              </div>
            </ButtonBase>
          </Box>
          <Box marginBottom="20px" maxWidth="300px">
            <ButtonBase onClick={() => onSelectStep(STEPS.SCHEDULE)}>
              <div className={classes.selectItem}>
                <div className={classes.itemIcon}>
                  <Schedule width="33" height="22" />
                </div>
                <div className={classes.itemTitle}>Schedule</div>
              </div>
            </ButtonBase>
          </Box>
        </div>
      </div>
    )
  } else {
    return (
      <div className={classes[`sideSelect${opened ? 'Active' : ''}`]}>
        <div className={classes.sideSelectHeader}>
          Please save your current Trigger
        </div>
      </div>
    )
  }
}

export default withStyles(style)(Sidebar)
